import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Input } from '../../../system/components/Input';

interface Props {
  form: WrappedFormUtils;
  required?: boolean;
}

export const InputPatientPhone: FC<Props> = ({ form, required = false }): JSX.Element => (
  <Form.Item label="Phone Number">
    {form.getFieldDecorator('phone', {
      rules: [
        {
          transform: (v: string) => {
            return v?.match(/\d+/g)?.join('');
          },
        },
        {
          len: 10,
          message: 'Please enter 10 digits',
        },
        {
          required: required,
          message: "Please enter patient's phone number.",
        },
      ],
    })(<Input allowClear />)}
  </Form.Item>
);
